import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { QueryQuizSessionsTrackingQuery, QueryQuizSessionsTrackingQueryPayload } from '../api'
import { QuizSessionSuspendDataStore } from '../common';
import { QueryHandler } from '@/app/tracking/common';

const debug = Debug('scorm2004-query-quiz-sessions-query-handler')

@injectable()
export class Scorm2004QueryQuizSessionsQueryHandler implements QueryHandler<QueryQuizSessionsTrackingQuery> {

  constructor (
    @inject(QuizSessionSuspendDataStore)
    private store: QuizSessionSuspendDataStore,
  ) {}
  
  public async execute(query: QueryQuizSessionsTrackingQueryPayload) {

    debug('execute', query)

    const sessions = await this.store.query('all')

    debug('sessions', sessions)

    return {
      sessions
    }
  }
}
